<div class="MainContainer">

    <div class="MainTitleBar">
        <p class="SectionHalfTitle" style="margin-top: 0%;">{{ 'StockBalance' | translate }}</p>
        <div class="SectionHalfTitle SectionHalfTitleRight">
            <button (click)="ExportStockBalanceValues();" style="padding-left: 10px;background:#32aa3a;" mat-raised-button color="primary"><i class="material-icons">file_download</i> {{'Export' | translate}}</button>
        </div>
    </div>

    <div class="overlay" *ngIf="ShowCashCollectionContainer || showEditPartnerPopUp || showInvoiceVisualizer;" (click)="showEditPartnerPopUp = false; showInvoiceVisualizer = false;"></div>

    <div class="MainTitleBar" style="overflow: hidden;">
        <div class="MainTitleBarIconContainer">
          <i class="material-icons">date_range</i>
        </div>
      
        <div class="FifteenPercentContainer">
          <mat-form-field class="ReceptionProductsColDropDown" appearance="outline">
            <mat-label>{{ 'Receptions.ChoosePeriod' | translate }}</mat-label>
            <mat-select name="Administration" [(ngModel)]="Filter.Period">
              <mat-option *ngFor="let a of this.Periods;" [value]="a" (click)="AddActiveFilter(a.Name, 'Period'); GetStockBalance();">
                {{a.Name}}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      
        <div class="MainTitleBarIconContainer">
          <i class="material-icons">date_range</i>
        </div>
      
        <div class="FifteenPercentContainer">
          <mat-form-field appearance="outline">
            <mat-label>{{ 'Receptions.FromDate' | translate }}</mat-label>
            <input matInput [matDatepicker]="dp" [formControl]="FromDate" [(ngModel)]="Filter.FromDate" (dateChange)="ClearPeriod()">
            <mat-datepicker-toggle matSuffix [for]="dp"></mat-datepicker-toggle>
            <mat-datepicker #dp></mat-datepicker>
          </mat-form-field>
        </div>
      
        <div class="MainTitleBarIconContainer">
          <i class="material-icons">date_range</i>
        </div>
      
        <div class="FifteenPercentContainer">
          <mat-form-field appearance="outline">
            <mat-label>{{ 'Receptions.ToDate' | translate }}</mat-label>
            <input matInput [matDatepicker]="dp1" [formControl]="ToDate" [(ngModel)]="Filter.ToDate" (click)="DisablePeriod();" (dateChange)="ClearPeriod()">
            <mat-datepicker-toggle matSuffix [for]="dp1"></mat-datepicker-toggle>
            <mat-datepicker #dp1></mat-datepicker>
          </mat-form-field>
        </div>
      
        <div class="FifteenPercentContainer" style="margin-top: -4px;">
            <button mat-mini-fab aria-label="Example icon button with a home icon" color="primary" (click)="GetStockBalance();">
              <mat-icon>filter_alt</mat-icon>
            </button>
        </div>
      
      </div>

      <div class="MainTitleBar" style="overflow: unset;">
        <div class="FilterButton noselect" (click)="this.showFilter = !this.showFilter;">
            <i class="material-icons">filter_alt</i>
            <span>Filter</span>
        </div>
    
        <div class="ActiveFiltersContainer">
          <div class="ActiveFilter" *ngFor="let a of this.activeFilters;" (click)="RemoveActiveFilter(a.ID, a.Type);">
            {{a.Name}}
            <i class="material-icons">close</i>
          </div>
        </div>
    
        <div class="FilterContainer animated fadeIn" *ngIf="showFilter">
            <div class="FilterCloseContainer" (click)="this.showFilter = false;">
                <i class="material-icons">close</i>
            </div>
    
            <div class="FilterContainerBody">
    
                <div class="PopUpBodyRow">
                  
                </div>
    
                <div class="PopUpBodyOneThirddContainer">
                    <mat-form-field class="ReceptionProductsColDropDown" appearance="outline">
                        <mat-label>{{ 'Receptions.Administration' | translate }}</mat-label>
                        <mat-select name="Administration" [(ngModel)]="Filter.Administration">
                          <mat-option *ngFor="let a of this.Administrations;" [value]="a" (click)="AddActiveFilter(a.Name, 'Administration');">
                            {{a.Name}}
                          </mat-option>
                        </mat-select>
                      </mat-form-field>
                </div>
                
                <div class="PopUpBodyTwoThirdsContainer">
                    <mat-form-field appearance="outline" class="ReceptionProductsColDropDown">
                        <mat-label>{{ 'SearchProductInvoicesFilter' | translate }}*</mat-label>
                        <input matInput placeholder="Product*" autocomplete="off" [(ngModel)]="Filter.Product" (change)="AddActiveFilter('PN: ' + Filter.Product, 'Product');">
                      </mat-form-field>
                </div>
              
            </div>
            
            <div class="FilterCommands">
                <button mat-raised-button color="primary" class="FilterButtonAction" (click)="GetStockBalance();">{{ 'FilterStock' | translate }}</button>
            </div>
        </div>

        <div class="TotalDocCountContainer" *ngIf="this.StockBalanceAdministrations != undefined;">
          <span style="float: right;">{{this.StockBalanceAdministrations.length}} {{'OfWord' | translate}} {{this.Filter.Pager.TotalCount}} {{'Invoices' | translate}} ({{'Page' | translate}}: {{this.Filter.Pager.PageIndex}} {{'OfWord' | translate}} {{this.Filter.Pager.Pages}})</span>
          <div class="PageSizeContainer">
            <mat-form-field appearance="outline" class="PageSizeTextBox">
              <mat-label>{{ 'PageSize' | translate }}*</mat-label>
              <input matInput autocomplete="off" [(ngModel)]="Filter.Pager.PageSize" (change)="GetStockBalance(1);">
            </mat-form-field>
          </div>
        </div>

        <div class="TotalDocCountContainer">
          <div class="TopPagingButton unSelectable" *ngIf="this.Filter.Pager.PageIndex != 1;" (click)="GetStockBalance(this.Filter.Pager.PageIndex - 1);">
            <i class="material-icons">chevron_left</i>
          </div>
          <div class="TopPagingButton unSelectable" *ngIf="this.Filter.Pager.PageIndex == 1;" style="background: #eee;columns: #aaa;cursor: not-allowed;">
            <i class="material-icons">chevron_left</i>
          </div>

          <div class="TopPagingButton unSelectable" *ngIf="this.Filter.Pager.PageIndex != this.Filter.Pager.Pages;" (click)="GetStockBalance(this.Filter.Pager.PageIndex + 1);">
            <i class="material-icons">chevron_right</i>
          </div>
          <div class="TopPagingButton unSelectable" *ngIf="this.Filter.Pager.PageIndex == this.Filter.Pager.Pages;" style="background: #eee;columns: #aaa;cursor: not-allowed;">
            <i class="material-icons">chevron_right</i>
          </div>
        </div>
    </div>

    <div class="MainBody">

        <div class="ReceptionProductsContainer">
          
            <div class="ReceptionProductsHeadder ReceptionProductsRow" style="border: none;">
              
                <div class="ReceptionProductsCol" style="width: 25%;text-align: left;padding-left: 2%;">
                    {{ 'Receptions.Administration' | translate }}
                </div>
                <div class="ReceptionProductsCol" style="width: 5%;">
                    {{ 'Receptions.Table.MU' | translate }}
                  </div>
                  <div class="ReceptionProductsCol" style="width: 7.5%;">
                    {{ 'InitialStock' | translate }}
                  </div>
                  <div class="ReceptionProductsCol" style="width: 7.5%;">
                    {{ 'Ins' | translate }}
                  </div>
                  <div class="ReceptionProductsCol" style="width: 7.5%;">
                    {{ 'Outs' | translate }}
                  </div>
                  <div class="ReceptionProductsCol" style="width: 7.5%;">
                    {{ 'FinalStock' | translate }}
                  </div>
                  <div class="ReceptionProductsCol" style="width: 10%;">
                    {{ 'InitialSums' | translate }}
                  </div>
                  <div class="ReceptionProductsCol" style="width: 10%;">
                    {{ 'Ins' | translate }}
                  </div>
                  <div class="ReceptionProductsCol" style="width: 10%;">
                    {{ 'Outs' | translate }}
                  </div>
                  <div class="ReceptionProductsCol" style="width: 10%;">
                    {{ 'FinalSums' | translate }}
                  </div>
            </div>
    
            <div class="ReceptionProductsRow TotalRow" *ngIf="loading">
                <mat-spinner class="smallSpinner" [diameter]="30"></mat-spinner>
            </div>
            <div *ngIf="!loading">
                <div class="ReceptionProductsRow ReceptionProductsRowHover" *ngFor="let partent of this.StockBalanceAdministrations; let i=index;" style="border:none;">
                    <div class="ReceptionProductsColParent">
                       <div class="ReceptionProductsColParentTitle">
                           {{partent.Administration.Name}}
                       </div>
    
                       <div class="ReceptionProductsColParentContent" *ngFor="let item of partent.StockBalances; let j=index;">
                        <div class="ReceptionProductsCol ConcatenatedCol" style="width: 25%;text-align: left;padding-left: 2%;">
                            <span>({{item.ProductCode}})</span>
                            {{item.ProductName}}
                        </div>
                        <div class="ReceptionProductsCol" style="width: 5%;">
                            {{item.MeasuringUnit.Name}}
                          </div>
                          <div class="ReceptionProductsCol" style="width: 7.5%;">
                            {{item.Initial}}
                          </div>
                          <div class="ReceptionProductsCol" style="width: 7.5%;">
                            {{item.Ins}}
                          </div>
                          <div class="ReceptionProductsCol" style="width: 7.5%;">
                            {{item.Outs}}
                          </div>
                          <div class="ReceptionProductsCol" style="width: 7.5%;">
                            {{item.Final}}
                          </div>
                          <div class="ReceptionProductsCol" style="width: 10%;">
                            {{item.InitialSum}}
                          </div>
                          <div class="ReceptionProductsCol" style="width: 10%;">
                            {{item.InsSum}}
                          </div>
                          <div class="ReceptionProductsCol" style="width: 10%;">
                            {{item.OutsSum}}
                          </div>
                          <div class="ReceptionProductsCol" style="width: 10%;">
                            {{item.FinalSum}}
                          </div>
                       </div>
                    </div>
                </div>

                <div class="ReceptionProductsRow" style="border:none;" *ngIf="InitialTotal != null;">
                    <div class="ReceptionProductsColParent">
                       <div class="ReceptionProductsColParentTitle">
                           
                       </div>
    
                       <div class="ReceptionProductsColParentContent">
                        <div class="ReceptionProductsCol ConcatenatedCol" style="width: 25%;text-align: left;padding-left: 2%;">
                            
                        </div>
                        <div class="ReceptionProductsCol" style="width: 5%;">
                            
                          </div>
                          <div class="ReceptionProductsCol" style="width: 7.5%;">
                            
                          </div>
                          <div class="ReceptionProductsCol" style="width: 7.5%;">
                           
                          </div>
                          <div class="ReceptionProductsCol" style="width: 7.5%;">
                           
                          </div>
                          <div class="ReceptionProductsCol" style="width: 7.5%;">
                            Total:
                          </div>
                          <div class="ReceptionProductsCol" style="width: 10%;font-weight: bold;">
                            <p>{{InitialTotal.UITotalQtyPriceNOVAT.Integer}} <span class="DecimalsSpan">{{InitialTotal.UITotalQtyPriceNOVAT.Decimals}}</span></p>
                          </div>
                          <div class="ReceptionProductsCol" style="width: 10%;font-weight: bold;">
                            <p>{{InsTotal.UITotalQtyPriceNOVAT.Integer}} <span class="DecimalsSpan">{{InsTotal.UITotalQtyPriceNOVAT.Decimals}}</span></p>
                          </div>
                          <div class="ReceptionProductsCol" style="width: 10%;font-weight: bold;">
                            <p>{{OutsTotal.UITotalQtyPriceNOVAT.Integer}} <span class="DecimalsSpan">{{OutsTotal.UITotalQtyPriceNOVAT.Decimals}}</span></p>
                          </div>
                          <div class="ReceptionProductsCol" style="width: 10%;font-weight: bold;">
                            <p>{{FinalTotal.UITotalQtyPriceNOVAT.Integer}} <span class="DecimalsSpan">{{FinalTotal.UITotalQtyPriceNOVAT.Decimals}}</span></p>
                          </div>
                       </div>
                    </div>
                </div>

                <div class="ReceptionProductsRow ReceptionProductsRowHover TotalRow" *ngIf="!loading && StockBalanceAdministrations.length > 0;">
                    <div class="ReceptionProductsCol" style="width: 10%;">
              
                    </div>
                    <div class="ReceptionProductsCol" style="width: 20%;">
                    </div>
                    <div class="ReceptionProductsCol" style="width: 10%;text-align: left;padding-left: 1%;">
                    </div>
                    <div class="ReceptionProductsCol totalCol" style="width: 10%;">
                      <button mat-raised-button *ngIf="this.Filter.Pager.PageIndex != 1;" (click)="GetStockBalance(this.Filter.Pager.PageIndex - 1);">
                        <i class="material-icons">chevron_left</i>
                      </button>
              
                      <button mat-raised-button *ngIf="this.Filter.Pager.PageIndex == 1;" style="background: #eee;cursor: not-allowed;">
                        <i class="material-icons">chevron_left</i>
                      </button>
                    </div>
                    <div class="ReceptionProductsCol totalCol" style="width: 10%;">
                      {{this.Filter.Pager.PageIndex}} / {{this.Filter.Pager.Pages}}
                    </div>
                    <div class="ReceptionProductsCol totalCol" style="width: 10%;">
                      <button mat-raised-button *ngIf="this.Filter.Pager.PageIndex != this.Filter.Pager.Pages;" (click)="GetStockBalance(this.Filter.Pager.PageIndex + 1);">
                        <i class="material-icons">chevron_right</i>
                      </button>
              
                      <button mat-raised-button *ngIf="this.Filter.Pager.PageIndex == this.Filter.Pager.Pages;" style="background: #eee;cursor: not-allowed;">
                        <i class="material-icons">chevron_right</i>
                      </button>
                    </div>
                    <div class="ReceptionProductsCol totalCol" style="width: 10%;">
                        
                    </div>
                    <div class="ReceptionProductsCol totalCol" style="width: 10%;">
                        
                    </div>
                    <div class="ReceptionProductsCol" style="width: 10%;">
                        
                    </div>
                </div>
            </div>
        </div>
    
    </div>

</div>
